var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulseCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 24,
    viewBox: "0 0 58 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.3827 7.07612C12.7564 7.2309 13 7.59554 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V10.4142L10.7071 10.7071C10.3166 11.0976 9.68342 11.0976 9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289L11.2929 7.29289C11.5789 7.0069 12.009 6.92134 12.3827 7.07612Z",
    fill: "#CC5DE8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 11.0166,
    width: 1.96631,
    height: 8,
    rx: 0.983154,
    transform: "rotate(90 33 11.0166)",
    fill: "#CC5DE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 4C41.5817 4 38 7.58172 38 12C38 16.4183 41.5817 20 46 20C50.4183 20 54 16.4183 54 12C54 7.58172 50.4183 4 46 4ZM36 12C36 6.47715 40.4772 2 46 2C51.5228 2 56 6.47715 56 12C56 17.5228 51.5228 22 46 22C40.4772 22 36 17.5228 36 12ZM43 8C43 7.44772 43.4477 7 44 7H48C48.5523 7 49 7.44772 49 8C49 8.55228 48.5523 9 48 9H45V11H47C47.5304 11 48.0391 11.2107 48.4142 11.5858C48.7893 11.9609 49 12.4696 49 13V15C49 15.5304 48.7893 16.0391 48.4142 16.4142C48.0391 16.7893 47.5304 17 47 17H45C44.4696 17 43.9609 16.7893 43.5858 16.4142C43.2107 16.0391 43 15.5304 43 15C43 14.4477 43.4477 14 44 14C44.5523 14 45 14.4477 45 15H47V13H44C43.4477 13 43 12.5523 43 12V8Z",
    fill: "#CC5DE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseCheckIcon);
export default __webpack_public_path__ + "static/media/PulseCheckIcon.dad8a54a3dd61d7eccab122421cf8993.svg";
export { ForwardRef as ReactComponent };